var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvChargingOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "evOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.028,
    cy: 30.241,
    r: 29.946,
    style: {
      fill: "#4888ad"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.987,16.578l-16.736,-0.015c-1.901,0.011 -2.473,0.456 -2.452,2.26l-0.025,15.322c-0.007,4.22 1.693,3.914 5.243,3.92",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.631,35.655l0.001,6.272l2.04,2.671l2.434,-0c0.295,-1.68 1.088,-2.862 2.973,-2.951c1.455,0.133 2.52,0.98 2.974,2.951l10.486,-0c0.009,-2.191 1.396,-2.957 2.974,-2.951c1.779,-0.197 2.778,0.615 3.026,2.849c1.825,0.043 3.605,-0.543 4.348,-0.797c1.037,-0.445 2.257,-1.541 2.29,-3.409c-0,-3.574 -2.575,-4.545 -5.393,-4.745c-5.678,-0.404 -28.153,0.11 -28.153,0.11Z",
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.513,
    cy: 44.639,
    rx: 2.973,
    ry: 2.951,
    style: {
      fill: "#4888ad",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.079,
    cy: 44.639,
    rx: 2.973,
    ry: 2.951,
    style: {
      fill: "#4888ad",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.167,36.336l-11.281,-0l0,-3.958c-0.011,-0.627 0.316,-1.583 0.914,-1.985c0.769,-0.518 1.953,-0.398 3.11,-0.416c-0,0 3.936,-0.013 7.074,0l0.183,6.359Z",
    style: {
      fill: "#4888ad",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.447,36.257l-14.367,0.071l-0.185,-6.359c0,0 4.107,0.02 7.783,0.038l6.769,6.25Z",
    style: {
      fill: "#4888ad",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.515,18.84l3.422,-0.007",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.515,14.298l3.422,-0.005",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.154,16.717c0.021,-3.464 2.795,-4.434 7.254,-4.499l0.107,9.076c-4.758,-0.035 -7.382,-1.028 -7.361,-4.577Z",
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargingOne);
export default __webpack_public_path__ + "static/media/evChargingOne.10215e478f50c7e4d4d729422a58309c.svg";
export { ForwardRef as ReactComponent };